import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import RestService from '../../services/core-rest.service';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
	standalone: true,
	selector: 'modal-questionnaire-search',
	templateUrl: './modal-questionnaire-search.component.html',
	imports: [ CommonModule, MatSelectModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalQuestionnaireSearchComponent implements OnInit {
	private restService: RestService = inject(RestService);
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dialogRef = inject(MatDialogRef<ModalQuestionnaireSearchComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.initialize();
		
		this.vm.close = this.close;
		this.vm.submit = this.submit;
	}
	
	initialize() {
		this.vm.getLanguagesText = this.getLanguagesText;
		this.vm.getQuestionnaireText = this.getQuestionnaireText;
		this.vm.selectedLang = 'en_GB';
		
		this.vm.sessionUserLanguage = this.session.getSession().user && this.session.getSession().user.deviceLanguage;
		
		this.restService.getQuestionnaireSearch({ userId: this.vm.chat.privateChatFriend.id })
			.then((result) => {
				this.vm.questionnaires = result.questionnaires;
				this.vm.searchLanguages = result.languages;
				this.vm.selectedLang = result.customerLanguage;
				this.vm.initialized = true;
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
	submit() {
		if (this.vm.processing || !this.vm.initialized) return;
		if (!this.vm.selectedQuestionnaire) {
			this.dialogRef.close(this.vm.chat);
			return;
		}
		this.vm.processing = true;
		
		this.submitQuestionnaireToChat().then(
			(res) => {
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.NEW_MESSAGE,
					res.flat(), this.vm.chat.id);
				this.dialogRef.close(this.vm.chat);
			},
			(err) => {
				this.vm.processing = false;
			}
		);
	}
	
	submitQuestionnaireToChat() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		var params = { userId: this.vm.chat.privateChatFriend.id, language: this.vm.selectedLang };
		this.restService.saveQuestionnaireShare(params, this.vm.selectedQuestionnaire)
			.then((chatPosts) => {
				deferred.resolve(chatPosts);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});
		
		return deferred.promise;
	}
	
	getLanguagesText() {
		if (!this.vm.selectedLang) return this.angularFilterHelperService.translate('Services.Filter.Languages');
		return this.vm.selectedLang;
	}
	
	getQuestionnaireText() {
		if (!this.vm.selectedQuestionnaire) return this.angularFilterHelperService.translate('Services.Filter.Questionnaire');
		return this.vm.selectedQuestionnaire.codeName;
	}
	
	close() {
		this.dialogRef.close(this.vm.chat);
	}
	
}